import React from "react";
import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const img = "https://images.unsplash.com/photo-1584030373081-f37b7bb4fa8e?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function ProgettiSartoriali() {
  return (
    <Layout>
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-16 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6">
          <div className="overline">Progetti Speciali</div>
          <h1 className="font-display text-5xl lg:text-7xl leading-[0.95] mt-3">Sartoriale.</h1>
          <p className="mt-6 text-lg text-[#6B6960] leading-relaxed max-w-lg" data-testid="sartoriale-intro">
            Ogni progetto ha una sua storia… Comincia a raccontarci la tua e realizziamolo assieme!
          </p>
          <div className="mt-8 flex gap-3">
            <Link to="/contatti"><Button className="btn-primary-cdm rounded-full h-11 px-6">Raccontaci il progetto</Button></Link>
          </div>
        </div>
        <div className="lg:col-span-6 aspect-[4/5] overflow-hidden">
          <img src={img} alt="Sartoria artigiana" className="w-full h-full object-cover" />
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 border-t border-[#E2DFD6] grid grid-cols-1 md:grid-cols-3 gap-10">
        {[
          { t: "Editoria d'autore", d: "Libri artistici, cataloghi museali, edizioni limitate stampate a torchio." },
          { t: "Packaging & Inviti", d: "Progetti di stampa fine art, tirature limitate, carta di pregio, incisioni." },
          { t: "Capsule Tessili", d: "Piccole collezioni sartoriali con laboratori a Corte della Miniera." },
        ].map((s) => (
          <div key={s.t}>
            <h3 className="font-display text-2xl">{s.t}</h3>
            <p className="mt-3 text-[#6B6960] leading-relaxed text-sm">{s.d}</p>
          </div>
        ))}
      </section>
    </Layout>
  );
}
